import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import useUserProfileStore from '../../stores/userProfileStore';
import moment from 'moment';
import { USER_ROLES, USER_ROLE_OPTIONS, getStoredUserRoleFromUserDoc } from '../../utils/accessControl';

export default function UserExtraDetails() {
    const userDoc = useUserProfileStore(state => state.userDoc);
    const setUserDoc = useUserProfileStore(state => state.setUserDoc);
    const currentViewerRole = useUserProfileStore(state => state.role);
    const canEditUserRole = currentViewerRole === USER_ROLES.ADMIN;

    const handleChange = (event) => {
        const fieldName = event.target.name || event.target.id;
        if (!fieldName) {
            return;
        }

        setUserDoc({
            ...userDoc,
            [fieldName]: event.target.value
        });
    };

    const selectedUserRole = getStoredUserRoleFromUserDoc(userDoc) ?? '';

    return (
        <>
            <div style={{ marginTop: '20px' }} />
            <div >
                User extra details
            </div>
            {/* line break */}
            <div style={{ marginTop: '20px' }} />

            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
            //   noValidate
            //   autoComplete="off"
            >
                <div>
                    <TextField
                        id="createdAt"
                        label="Date joined"
                        value={userDoc.createdAt ? moment.unix(userDoc.createdAt.seconds).format('MMMM Do YYYY') : ''}
                        multiline
                        maxRows={4}
                        onChange={handleChange}
                        // Make non-editable
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='filled'
                    />
                    <TextField
                        id="updatedTime"
                        label="User last updated"
                        value={userDoc.updatedTime ? moment.unix(userDoc.updatedTime.seconds).format('MMMM Do YYYY') : ''}
                        onChange={handleChange}
                        // Make non-editable
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='filled'
                    />
                    <TextField
                        id="expoPushToken"
                        label="Expo Push Token"
                        value={userDoc.expoPushToken ?? ''}
                        //   Width
                        style={{ width: '400px' }}
                        onChange={handleChange}

                        // Make non-editable
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='filled'

                    />
                </div>
                <div>
                    <TextField
                        id="isEmailVerified"
                        label="Email is verified?"
                        value={userDoc.isEmailVerified ? 'Yes' : 'No'}
                        onChange={handleChange}
                        // Make non-editable
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='filled'
                    />
                    <TextField
                        id="subscribeToNewsletter"
                        label="Subscribed to newsletter?"
                        value={userDoc.subscribeToNewsletter ? 'Yes' : 'No'}
                        onChange={handleChange}
                        // Make non-editable
                        InputProps={{
                            readOnly: true,
                        }}
                        variant='filled'
                    />
                    <TextField
                        id="userRole"
                        name="userRole"
                        label="User role"
                        select
                        value={selectedUserRole}
                        onChange={handleChange}
                        disabled={!canEditUserRole}
                        helperText={canEditUserRole ? 'Admins can change this role.' : 'Only admins can change this role.'}
                        FormHelperTextProps={{
                            sx: {
                                color: 'var(--color-muted) !important',
                            },
                        }}
                        variant="filled"
                    >
                        {USER_ROLE_OPTIONS.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            </Box>
        </>
    );
}
